import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Breadcrumb from "../Component/Breadcrumb"
const AimsObject = () => {
    return (
        <>
            <Header />
            <Breadcrumb title="Aims and Objectives" midBreadcrumb="School" mainBreadcrumb="Aims and Objectives" ></Breadcrumb>
            <div className='inner-page'>
                <div className='container'>
                    <div className="col-12">
                        <p>The aim of any good educational institution is to discover and to develop the qualities and talents in a human being. Besides striving to bring about a holistic development of the qualities in a person, the Institution tries its best to inculcate in every student the spirit of social awareness. The Institution deems it its bounded duty to facilitate and develop the natural, physical and spiritual talents of its students. </p>

                        <div className="row g-2 mt-3 mb-4 box3-main">
                            <div className="col">
                                <div className="p-3 box3">
                                    <h3 className="subhead">Our Vision</h3>
                                    <p>To prepare dynamic and caring citizens, who will meet the challenges of a global society while retaining their traditional values.</p>
                                    <p>To be a centre for excellence in education, and in keeping with the rich heritage of India will stress the simultaneous development of the Spirit, Mind and Body. We will endeavour to create compassionate, responsible and innovative global citizens who are committed to the development of India.</p>
                                </div>
                            </div>
                            <div className="col">
                                <div className="bg-light box3">
                                    <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/MMJSVN/public/images/aim-objective.png" className="img-fluid mx-auto d-block" alt="matamariamjansevavidyalayas" />
                                </div>
                            </div>
                        </div>

                        <h3 className="subhead" id="core_value">Our Core Values</h3>
                        <p>The core ideology of this institution is to impart quality education to all its students. The emphasis is on formation of good human beings and citizens who can in turn contribute to the society and its welfare.
                        </p>

                        <h3 className="subhead" id="objective">Objectivess</h3>
                        <div className="row timeline">
                            <div className="col-md-6">
                                <ul className="listview">
                                    <li>To provide a near-ideal ambience, outstanding teaching resource and facilities to foster all round development.</li>
                                    <li>To nurture and promote intellectual abilities.</li>
                                    <li>To inculcate a system of values and purity of thought.</li>
                                    <li>To encourage development of scientific and rational thinking.</li>
                                </ul>
                            </div>
                            <div className="col-md-6">
                                <ul className="listview">
                                    <li>To develop Leadership and a spirit of adventure.</li>
                                    <li>To foster the ability to distinguish the right from the wrong, fact from the myth, the grain from the chaff.</li>
                                    <li>To encourage community feeling, a sence of justice and the quality of tolerance.</li>
                                    <li>To develop self-confidence through a sence of responsibility, devotion, patriotism and discipline</li>
                                </ul>
                            </div>
                        </div>
                        <h3 className="subhead" id="#guid-prin">Guiding Principles</h3>
                        <div className="row mb-4">
                            <div className="col-md-6 bg-1">
                                <ul className="listview">
                                    <li>Giving primacy to character formation that leads to the choice of a life of service.</li>
                                    <li>Quality education based on holistic principles for life.</li>
                                    <li>Building educational communities in a family atmosphere of partnership.</li>
                                </ul>
                            </div>
                            <div className="col-md-6 bg-2">
                                <ul className="listview">
                                    <li>Strategic participatory planning.</li>
                                    <li>Moving away from rote learning to meaningful assimilative learning.</li>
                                    <li>Involving students actively in the process of learning.</li>
                                </ul>
                            </div>
                        </div>
                        <h3 className="subhead" id="#chief-prior">Chief Priorities</h3>
                        <div className="row">
                            <div className="col-md-6 bg-3">
                                <ul className="listview">
                                    <li>Character formation.</li>
                                    <li>Unambiguous preference for the poor and the deserving.</li>
                                </ul>
                            </div>
                            <div className="col-md-6 bg-4">
                                <ul className="listview">
                                    <li>Sense of community and net-working.</li>
                                    <li>Holistic education</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
export default AimsObject